export const BLOCK_TYPE_LINK_LIST_SELECTION = 'linkListSelection';
